import { Component, Input, OnInit } from '@angular/core';
import { LoggerService } from '@app/core/services/logger.service';
const logger = new LoggerService('ShowValidationsInputPasswordComponent');

@Component({
  selector: 'dhl-show-validations-input-password',
  templateUrl: './show-validations-input-password.component.html',
  styleUrls: ['./show-validations-input-password.component.scss']
})
export class ShowValidationsInputPasswordComponent implements OnInit{

  @Input() password!: string;

  LOWERCASE_REGULAR_EXPRESION = /[a-z]/;
  UPPERCASE_REGULAR_EXPRESION = /[A-Z]/;
  NUMBER_REGULAR_EXPRESION = /[0-9]/;
  CHARACTER_SPECIAL_REGULAR_EXPRESION = /[\W_]/;
  LENGHT_8_REGULAR_EXPRESION = /.{8}/;

  validationLowerCase: boolean = false;
  validationUpperCase: boolean = false;
  validationSpecialCharacters: boolean = false;
  validationNumber: boolean = false;
  validationLength: boolean = false;

  constructor(){
    logger.debug("constructor init show validations passwords");
  }

  ngOnInit(): void {
    logger.debug("Init component");
  }

  validatePassword(password: string){
    if(this.LOWERCASE_REGULAR_EXPRESION.test(password)){
      this.validationLowerCase = true;
    }else{
      this.validationLowerCase = false;
    }
    if(this.UPPERCASE_REGULAR_EXPRESION.test(password)){
      this.validationUpperCase = true;
    }else{
      this.validationUpperCase = false;
    }
    if(this.NUMBER_REGULAR_EXPRESION.test(password)){
      this.validationNumber = true;
    }else{
      this.validationNumber = false;
    }
    if(this.CHARACTER_SPECIAL_REGULAR_EXPRESION.test(password)){
      this.validationSpecialCharacters = true;
    }else{
      this.validationSpecialCharacters = false;
    }
    if(this.LENGHT_8_REGULAR_EXPRESION.test(password)){
      this.validationLength = true;
    }else{
      this.validationLength = false;
    }
  }

  isValidPassword(): boolean{
    if(!this.validationLowerCase || !this.validationUpperCase || !this.validationNumber || !this.validationSpecialCharacters || !this.validationLength){
      return false;
    }
    return true;
  }


}
